import { useFormContext, Controller } from 'react-hook-form'
import { Spacer, Input } from '@cb/apricot-react'
import { formatPhoneNumber, showNumbersOnly } from '@myap/ui-library'
import { isEmpty } from 'lodash'
import { FIELD_PHONE_NUMBER, FIELD_CONFIRM_PHONE_NUMBER } from '../constants'
import { validateFieldState, validateUsNumber, validateConfirmPhoneNumber } from '../validations'
import OpenNewWindow from '../../../_common/actions/OpenNewWindow'
import { InfoIconTooltip } from '../../../_common/apricot/Icons'

const US_PHONE_PLACEHOLDER = '(___) - ___ - ____'
// eslint-disable-next-line max-len
const SMS_TERMS_AND_CONDITIONS_URL = 'https://privacy.collegeboard.org/program-specific-privacy-policies/sms/bigfuture-school-sms-terms-conditions'
const PRIVACY_STATEMENT_URL = 'https://privacy.collegeboard.org/privacy-statement'

const getDisplayPhoneNumber = value => {
  const normalized = showNumbersOnly(value)
  return normalized.length === 10 ? formatPhoneNumber(normalized) : normalized
}

function BfsPhoneNumber() {
  const { control, getValues } = useFormContext()

  return (
    <>
      <Controller
        control={control}
        name={FIELD_PHONE_NUMBER}
        rules={{
          required: 'Phone number is required',
          validate: value => (!isEmpty(value) ? validateUsNumber(value) : undefined),
        }}
        render={({
          field: { onChange, onBlur, value, disabled, name },
          fieldState: { invalid, isDirty, isTouched, error },
        }) => (
          <Input
            label={<strong>Mobile Phone Number.</strong>}
            name={name}
            value={getDisplayPhoneNumber(value)}
            disabled={disabled}
            required
            placeholder={US_PHONE_PLACEHOLDER}
            onChange={onChange}
            onBlur={onBlur}
            clearable={false}
            floating={false}
            autoComplete="off"
            maxLength="10"
            validation={validateFieldState({
              invalid,
              isDirty,
              isTouched,
              error,
              value,
            })}
            validationMsg={error?.message}
          />
        )}
      />
      <ul style={{ listStyleType: 'disc' }}>
        <li>
          Sharing your mobile phone number is voluntary. Standard messaging and data rates apply.
          You may opt out of these text messages at any time.{' '}
          <InfoIconTooltip iconType="exclamation">
            <p>
              To stop receiving these SMS messages from College Board, text STOP to any text we send
              you about BigFuture School, or call customer service at (866) 630-9305. For additional
              help, text HELP to any text we send you or contact us at cb.org/contact.
            </p>
          </InfoIconTooltip>
        </li>
        <li>Do not provide a mobile number if you&#39;re under the age of 13.</li>
        <li>Only provide a domestic/U.S. mobile phone number.</li>
        <li>Do not share a mobile number that is shared with any other student.</li>
      </ul>
      <div style={{ paddingLeft: '2.1rem' }}>
        <OpenNewWindow url={SMS_TERMS_AND_CONDITIONS_URL}>SMS Terms and Conditions</OpenNewWindow>
      </div>
      <div style={{ paddingLeft: '2.1rem' }}>
        <OpenNewWindow url={PRIVACY_STATEMENT_URL}>Privacy Statement</OpenNewWindow>
      </div>
      <Spacer size="24" />
      <Controller
        control={control}
        name={FIELD_CONFIRM_PHONE_NUMBER}
        rules={{
          required: 'Confirm phone number is required',
          validate: value => validateConfirmPhoneNumber(getValues(FIELD_PHONE_NUMBER))(value),
        }}
        render={({
          field: { onChange, onBlur, value, disabled, name },
          fieldState: { invalid, isDirty, isTouched, error },
        }) => (
          <Input
            label={<strong>Confirm Mobile Phone Number</strong>}
            name={name}
            value={getDisplayPhoneNumber(value)}
            placeholder={US_PHONE_PLACEHOLDER}
            onChange={onChange}
            onBlur={onBlur}
            clearable={false}
            floating={false}
            autoComplete="off"
            maxLength="10"
            disabled={disabled}
            required
            validation={validateFieldState({
              invalid,
              isDirty,
              isTouched,
              error,
              value,
            })}
            validationMsg={error?.message}
          />
        )}
      />
    </>
  )
}

export default BfsPhoneNumber
